import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const TitleManager = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.toLowerCase();

        const staticTitles = {
            "/": "FlipTwirls - Online Shopping Portal | Shop Online",
            "/cart": "Cart - fliptwirls",
            "/about-us/": "About Us - fliptwirls",
            "/contact-us/": "Contact Us - fliptwirls",
            "/wishlist": "Your Wishlist - fliptwirls",
            "/checkout": "Checkout - fliptwirls",
            "/profile": "Your Profile - fliptwirls",
            "/my-account/": "Login - fliptwirls",
            "/register": "Register - fliptwirls",
            "/return-policy/": "Return Policy - fliptwirls",
            "/delivery-information/": "Delivery Info - fliptwirls",
            "/shipping-policy/": "Shipping Policy - fliptwirls",
            "/pricing-and-payments-policy/": "Pricing & Payment Policy - fliptwirls",
            "/disclaimer-policy/": "Disclaimer Policy - fliptwirls",
            "/prebooking-terms-and-conditions/": "Prebooking Terms - fliptwirls",
            "/refund-return/": "Refund & Return - fliptwirls",
            "/terms-of-service/": "Terms of Service - fliptwirls",
            "/privacy-policy": "Privacy Policy - fliptwirls",
            "/faq/": "FAQs - fliptwirls",
            "/how-to/": "How to Use - fliptwirls",
            "/track-your-order/": "Track Order - fliptwirls",
            "/thankyoupage": "Thank You - fliptwirls",
            "/topselldetails": "Top Selling Products - fliptwirls",
            "/all-cate": "All Categories - fliptwirls",
            "/allproductdata": "All Products - fliptwirls",
            "/orderplace": "Order Placed - fliptwirls",
            "/showsubcategorydata": "Sub Category - fliptwirls",
            "/subcategorydata": "Sub Category - fliptwirls",
            "/shop": "Product Details - fliptwirls",
            "/coupons": "Coupons - fliptwirls",
        };

        let title = staticTitles[path] || "fliptwirls | Bharat's Shopping Portal";

        if (path.startsWith("/product-category/")) {
            const parts = path.split("/");
            const categoryName = parts[2]?.replace(/-/g, " ");
            if (categoryName) {
                title = `Buy ${decodeURIComponent(categoryName)} - From fliptwirls`;
            }
        }

        if (path.startsWith("/showsubcategory/")) {
            const parts = path.split("/");
            const subCategoryName = parts[2]?.replace(/-/g, " ");
            if (subCategoryName) {
                title = `Buy ${decodeURIComponent(subCategoryName)} - From fliptwirls`;
            }
        }

        if (path.startsWith("/product/")) {
            const slug = path.split("/")[2]?.replace(/-/g, " ");
            if (slug) {
                title = `Buy ${decodeURIComponent(slug)} - fliptwirls Online Shopping Cash On Delivery`;
            }
        }

        if (path.startsWith("/category/")) {
            const parts = path.split("/");
            const categoryTitle = parts[3]?.replace(/-/g, " ");
            if (categoryTitle) {
                title = `Buy ${decodeURIComponent(categoryTitle)} - fliptwirls Online Shopping Cash On Delivery`;
            }
        }

        if (path.startsWith("/shop/")) {
            const parts = path.split("/");
            const rawTitle = parts[parts.length - 1];
            const formattedTitle = rawTitle.replace(/-/g, " ");
            title = `Buy ${decodeURIComponent(formattedTitle)} - fliptwirls Online Shopping Cash On Delivery`;
        }
        document.title = title;
    }, [location]);
    return null;
};

export default TitleManager;
